import React from 'react';
import { Link } from 'react-router-dom';

const Chevron = ({ open }) => (
  <svg
    aria-hidden="true"
    className={`csettings-section__chevron ${open ? 'is-open' : ''}`}
    fill="none"
    height="18"
    viewBox="0 0 24 24"
    width="18"
  >
    <path
      d="m6 9 6 6 6-6"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

const Arrow = () => (
  <svg
    aria-hidden="true"
    className="csettings-section__chevron"
    fill="none"
    height="18"
    viewBox="0 0 24 24"
    width="18"
  >
    <path
      d="m9 6 6 6-6 6"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

/**
 * AI 맞춤 설정 허브의 세로 섹션 카드.
 *
 * - 접힘/펼침은 부모가 제어한다 (open / onToggle). 해시 딥링크로 특정 섹션을 열기 위함.
 * - `to`가 있으면 접힘 카드가 아니라 다른 페이지로 가는 링크 카드가 된다 (생기부 내 스타일).
 * - 탭 대신 세로 카드 + 첫 카드 기본 펼침: 4050 교사 컴포넌트 인식 오류 대응.
 */
const SettingsSection = ({
  id,
  title,
  description,
  badge,
  open = false,
  onToggle,
  to,
  children,
}) => {
  const panelId = `${id}-panel`;

  if (to) {
    return (
      <section className="csettings-section csettings-section--link" id={id}>
        <Link className="csettings-section__head" to={to}>
          <span className="csettings-section__copy">
            <span className="csettings-section__title">{title}</span>
            {description && (
              <span className="csettings-section__desc">{description}</span>
            )}
          </span>
          <Arrow />
        </Link>
      </section>
    );
  }

  return (
    <section
      className={`csettings-section ${open ? 'is-open' : ''}`}
      id={id}
    >
      <button
        aria-controls={panelId}
        aria-expanded={open}
        className="csettings-section__head"
        onClick={() => onToggle?.(id)}
        type="button"
      >
        <span className="csettings-section__copy">
          <span className="csettings-section__title">
            {title}
            {badge !== undefined && badge !== null && badge !== '' && (
              <span className="csettings-section__badge">{badge}</span>
            )}
          </span>
          {description && (
            <span className="csettings-section__desc">{description}</span>
          )}
        </span>
        <Chevron open={open} />
      </button>
      {open && (
        <div className="csettings-section__body" id={panelId}>
          {children}
        </div>
      )}
    </section>
  );
};

export default SettingsSection;
